import { EntityActionConfirmDialogProps } from '../../entity-actions/interfaces/entity-actions';
import { JobAction } from '../interfaces/job-action';
import { Job, JobDetails } from '../interfaces/job';
import { JobsStrings } from '../strings';
import { JobsAPI } from '../JobsAPI';

export const JOB_ACTIONS_CONFIRMATION_DIALOG_PROPS: EntityActionConfirmDialogProps<
  JobAction,
  Job | JobDetails
> = {
  [JobAction.CANCEL]: {
    title: 'Cancel Job?',
    positiveButtonText: 'Cancel Job',
    negativeButtonText: 'Cancel',
    positiveBtnProps: {
      icon: 'close',
      variation: 'faded',
      palette: 'error'
    },
    successMessage: JobsStrings.cancelJobSuccessMessage,
    body: 'Canceling the job will lead to data inconsistency in your destination',
    actionHandler: args => JobsAPI.cancelJob(args.entity.jobId)
  },
  [JobAction.REFRESH]: {},
  [JobAction.DOWNLOAD_SESSION_LOGS]: {}
};
